export class GtmEnhancedEcommerceType {
    static NONE: string = "None";
    static PRODUCT_LIST: string = "Product list";
    static SEARCH_RESULTS: string = "Search Results";
}